// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : job wiki templates
// =============================================================================
// ---Third-party imports
import React, {useState} from 'react'

// ---Framework imports
import log from 'uix/logging'
import {keys, dict, filterItems} from 'ldash'
import {TagMatcher} from 'uix/wiki/utils'
import {HeaderSegment} from 'uix/components'

// ---Local imports
import {JobWikiButton, JobMenuButton, JobTable} from './components'
import {useJobFilterApi} from './hooks'
import styles from './styles.scss'
import {jobsIcon} from './utils'

// ---Exports
let extractParams = (attrib, ...exclude) => {
  return dict(filterItems(attrib, (name, value) => !exclude.includes(name)))
}

const completion = tag_name => ({jobSpec}) => {
  if (jobSpec) {
    let names = keys(jobSpec)
    return {'!top': [tag_name], [tag_name]: {attrs: {name: names, confirm: ['true', 'false']}}}
  }
}

const button_props = attrib => ({
  name: attrib.name,
  confirm: attrib.confirm === '' || attrib.confirm !== 'false',
  params: extractParams(attrib, 'name', 'confirm'),
})

export const Job = {
  match: ({tag}) => tag == 'Job',
  build: ({attrib}) => <JobWikiButton {...button_props(attrib)} />,
  completion: completion('Job'),
}

export const xmenu_jobbutton = {
  match: ({tag}) => tag == 'XMenu.Job',
  build: ({attrib}) => <JobMenuButton {...button_props(attrib)} />,
  completion: completion('XMenu.Job'),
}

export const JobTableMatcher = TagMatcher(
  'JobTable',
  ({names, days, numrows}) => {
    numrows = parseInt(numrows) || 8
    days = parseInt(days) || 7
    let {jobs, loading} = useJobFilterApi({names, days})
    let menu = null
    return (
      <HeaderSegment basic header="Jobs" loading={loading} icon={jobsIcon('eye')} menu={menu}>
        <JobTable compact flat jobs={jobs} pageSize={numrows} />
      </HeaderSegment>
    )
  },
  {names: ['import'], days: ['7'], numrows: ['8']},
  'List jobs in table form'
)
